import React     from 'react';
import PropTypes from "prop-types"
import plyr      from 'plyr';
import 'plyr/dist/plyr.css';

const propTypes = {
    jobApplication: PropTypes.object.isRequired,
    onPlay: PropTypes.func.isRequired
};

class Player extends React.Component {
    constructor() {
        super();

        this.video = React.createRef();
    }

    componentDidMount() {
        const compact = typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
        this.player = plyr.setup([this.video.current], {
            controls: compact
                ? ['play-large', 'play', 'progress', 'current-time', 'duration', 'captions', 'fullscreen']
                : ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'captions', 'fullscreen'],
            invertTime: false,
            toggleInvert: false
        })[0];

        this.player.on('playing', event => this.props.onPlay(event.detail.plyr))
    }

    componentWillUnmount() {
        this.player.destroy();
    }

    render() {
        return(
            <video
                playsInline
                preload="metadata"
                poster={this.props.jobApplication.attributes.transcoded_video_preview_url}
                ref={this.video}
                crossorigin="anonymous"
            >
                <source src={this.props.jobApplication.attributes.transcoded_video_url} type={this.props.jobApplication.attributes.video_content_type || 'video/mp4'}/>
                
                {
                   this.props.jobApplication.attributes.subtitles_url && (
                     <track label="English" srcLang="en" kind="subtitles" src={this.props.jobApplication.attributes.subtitles_url}  type="text/vtt" default />
                   )
                }
            </video>
        );
    }
}

Player.propTypes = propTypes;

export default Player;